import OlWind from './openlayers';
import AMapWind from './amap';
import BMapWind from './bmap';

export default {
  AMapWind,
  BMapWind,
  OlWind
}
